import { api, ApiRequestConfig } from './api';
import type { OrderStatusInfoRequest, OrderStatusInfo } from '../types/order-status';

export const getOrderStatus = (props: OrderStatusInfoRequest, config: ApiRequestConfig) =>
  api.get<OrderStatusInfo>('client-order-info', { ...props } as unknown as Record<string, string>, config);
